import { GenericChartComponent, getMouseCanvas, getStrokeDasharrayCanvas, noop } from 'react-financial-charts';
import * as React from 'react';
import type { StraightLineProps } from './InteractiveStraightLine';
import { isHovering } from './InteractiveStraightLine';
import type { MoreProps } from '@/types/commontypes';
// eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
const ChartComponent = GenericChartComponent as unknown as React.ComponentType<Record<string, unknown>>;

export class InteractiveStraightLineWithoutPoint extends React.Component<StraightLineProps> {
  public static defaultProps = {
    onEdge1Drag: noop,
    onEdge2Drag: noop,
    edgeStrokeWidth: 2,
    edgeStroke: '#1e53e6',
    edgeFill: '#FFFFFF',
    r: 5,
    withEdge: false,
    strokeWidth: 1,
    strokeDasharray: 'Solid',
    children: noop,
    tolerance: 7,
    selected: false,
    extendLeft: false,
    extendRight: false,
  };

  public render() {
    const { selected, interactiveCursorClass } = this.props;
    const { onDragStart, onDrag, onDragComplete, onHover, onUnHover } = this.props;
    return (
      <ChartComponent
        isHover={this.isHover}
        canvasToDraw={getMouseCanvas}
        canvasDraw={this.drawOnCanvas}
        interactiveCursorClass={interactiveCursorClass}
        selected={selected}
        onDragStart={onDragStart}
        onDrag={onDrag}
        onDragComplete={onDragComplete}
        onHover={onHover}
        onUnHover={onUnHover}
        drawOn={['mousemove', 'pan', 'drag']}
        onClick={this.handleClick}
        onMouseDown={this.handleMouseDown}
        onDoubleClick={this.handleDoubleClick}
        // key={interactiveCursorClass}
      />
    );
  }

  private readonly isHover = (moreProps: MoreProps) => {
    if (!moreProps) return null;
    const { tolerance, onHover } = this.props;

    if (onHover !== undefined) {
      const { x1Value, x2Value, type } = this.props;
      const { mouseXY, xScale } = moreProps;
      const {
        chartConfig: { yScale, height },
      } = moreProps;

      // 마우스가 차트 섹션 밖이면 호버 불가 (서브차트 간 이동 시 호버 고착 방지)
      if (mouseXY[1] < 0 || mouseXY[1] > height) return false;

      const [minY, maxY] = yScale.domain();
      const hovering = isHovering({
        x1Value,
        y1Value: minY,
        x2Value,
        y2Value: maxY,
        mouseXY,
        type,
        tolerance,
        xScale,
        yScale,
      });
      return hovering;
    }
    return false;
  };

  private readonly drawOnCanvas = (ctx: CanvasRenderingContext2D, moreProps: MoreProps) => {
    const {
      strokeWidth = InteractiveStraightLineWithoutPoint.defaultProps.strokeWidth,
      strokeDasharray,
      strokeStyle,
      x1Value,
    } = this.props;

    if (!x1Value) return;

    const {
      chartConfig: { yScale },
      xScale,
    } = moreProps;

    ctx.lineWidth = strokeWidth;
    ctx.strokeStyle = strokeStyle;

    const lineDash = getStrokeDasharrayCanvas(strokeDasharray);

    ctx.setLineDash(lineDash);

    ctx.beginPath();

    const x = xScale(x1Value); // scale the xValue
    const [minY, maxY] = yScale.domain();
    const y1Pixel = yScale(minY);
    const y2Pixel = yScale(maxY);

    ctx.moveTo(x, y1Pixel); // top of chart
    ctx.lineTo(x, y2Pixel); // bottom of chart

    ctx.stroke();
  };

  private readonly handleClick = (e: React.MouseEvent, moreProps: MoreProps) => {
    const isHovered = this.isHover(moreProps);
    if (isHovered && this.props.onClick) {
      this.props.onClick(e, moreProps);
    }
  };

  private readonly handleMouseDown = (e: React.MouseEvent, moreProps: MoreProps) => {
    const isHovered = this.isHover(moreProps);
    if (isHovered && this.props.onMouseDown) {
      this.props.onMouseDown(e, moreProps);
    }
  };

  private readonly handleDoubleClick = (e: React.MouseEvent, moreProps: MoreProps) => {
    if (this.isHover(moreProps)) {
      const { onDoubleClick } = this.props;
      if (onDoubleClick) {
        onDoubleClick(e, moreProps);
      }
    }
  };
}
export const findYpoint = (moreProps: MoreProps) => {
  const [minY, maxY] = moreProps.chartConfig.yScale.domain();
  const yOffsetData = (maxY - minY) * 0.8;
  const yVisible = Number((maxY - yOffsetData).toFixed(2));
  return { y1: minY, y2: yVisible };
};
